import { render, staticRenderFns } from "./GenealogyImporter.vue?vue&type=template&id=380915b4&"
import script from "./GenealogyImporter.vue?vue&type=script&lang=ts&"
export * from "./GenealogyImporter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports